module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_8004.c7587e83.png";